import React from 'react';
import { Navigate } from 'react-router-dom';
import { Typography } from 'antd';
import { useAuth } from '../../contexts/AuthContext';

const { Text } = Typography;

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <Text style={{ fontSize: 16 }}>Loading...</Text>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
